import "./case-studies.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import CaseStudiesCards from "@frontend/js/Components/Site/CaseStudiesCards/CaseStudiesCards";
import LoadMoreButton from "@frontend/js/Components/Shared/LoadMoreButton/LoadMoreButton";
import Pagination from "@frontend/js/Components/Shared/Pagination/Pagination";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import { resolvePreferredLocale } from "@frontend/js/utils/locale";
import { usePagination } from "@frontend/js/hooks/usePagination";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import { Head, usePage } from "@inertiajs/react";
import useT from "@frontend/js/hooks/useT";

export default function CaseStudies({
    page,
    collection,
    meta = {
        title: "",
        description: "",
    },
}) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const pageTitle = page?.title?.[locale] || "";

    const { filteredCards, localCollection, handleLoadMore, handlePageChange } =
        usePagination(collection, page.slug);

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="caseStudies page-shell">
                    <div className="caseStudies__container">
                        <PageTitleBreadcrumb title={pageTitle} />

                        <CaseStudiesCards cards={filteredCards} />
                    </div>
                    <LoadMoreButton
                        label={t("load-more-button-text")}
                        collection={localCollection}
                        locale={locale}
                        routeName="frontend.case_studies.filter"
                        onLoaded={handleLoadMore}
                        pageSlug={page.slug}
                    />
                    <Pagination
                        collection={localCollection}
                        onPageChange={handlePageChange}
                    />
                </div>
            </SiteLayout>
        </>
    );
}
